module.exports = __webpack_public_path__ + "dist/assets/img/Z.309f3e38.svg";